import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { about, allInOne, barkodOxuyucu, barkodPrinter, barkodProcessor, cardReader, carousel2, contact, dataTerminal, hero, pulQutulari, rightUp } from '../../../assets/index';
import { useTranslation } from 'react-i18next';


const Contact = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);
  return (
   <div className='rounded-[40px]'>
    <div className='max-w-containerSm md:max-w-container mx-auto mt-[44px] md:mt-[80px]'>
    <div className='md:flex gap-8'>
        <div className='md:w-[717px] flex flex-col justify-center mt-5 md:mt-0'>
            <p className='md:mb-6 mb-4 text-[24px] md:text-[40px] font-bold md:font-semibold font-barlow '>Biznesinizin böyüməsinə dəstək olmaq üçün birgə çalışaq. Suallarınız üçün bizimlə <span className='font-barlow text-[#E11E26]'>əlaqə yaradın.</span></p>
            <p className='mb-5'>Peşəkar komandamızla birgə çalışaraq, sizin üçün uyğun həllər təqdim edəcəyik. Gözəllik salonundan fitness mərkəzinə, hovuzdan geniş parking sahəsinə qədər, işinizin tələblərinə cavab verən hər cür xidmət burada mövcuddur.</p>
           <a href='/about'> <button className='rounded-[8px] w-[148px] border-[2px] hover:text-white hover:bg-[#898989] hover:border-[#898989] border-[#898989] h-[40px] flex items-center justify-center'>
  Əlaqə saxla
</button></a>
  
        </div>
        <div className='md:w-[593px] mt-5 md:mt-0'>
        <img className='rounded-[20px]' src={contact}></img>
        </div>
    </div>
   </div>
   </div>
  );
}; 
 
export default Contact; 